import { Truck, Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-secondary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="border-b border-white/10 pb-12 mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF5A4D] mb-3">
            Truck down? Call now.
          </p>
          <a
            href="tel:+14046356669"
            data-testid="footer-phone"
            className="block text-4xl sm:text-6xl font-black tracking-tighter hover:text-primary transition-colors duration-300"
            style={{ fontFamily: "Inter" }}
          >
            (404) 635-6669
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="bg-primary p-2 rounded-sm">
                <Truck className="w-5 h-5 text-white" strokeWidth={2.5} />
              </div>
              <span className="font-black text-lg tracking-tighter" style={{ fontFamily: "Inter" }}>
                F1 FLEET MAINTENANCE
              </span>
            </div>
            <p className="text-white/60 text-sm max-w-md leading-relaxed">
              Mobile semi-truck maintenance that comes to you. Oil changes, tire service, and brake
              repair across Atlanta and surrounding areas. Minimize downtime, maximize miles.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wide mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li>Mobile Oil Changes</li>
              <li>Mobile Tire Maintenance & Repair</li>
              <li>Mobile Brake Maintenance</li>
              <li>Fleet Programs</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wide mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#FF5A4D]" /> (404) 635-6669
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#FF5A4D]" /> Shawn@f1fleet.com
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-[#FF5A4D]" /> McDonough, GA
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} F1 Fleet Maintenance. All rights reserved.</span>
          <a href="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors">
            Dispatch Login
          </a>
        </div>
      </div>
    </footer>
  );
};
